module.exports = __webpack_public_path__ + "workspace/static/img/user-activity-log-one.c3c528d.png";